(function ($) {
    window.onload = function () {
        $('.preloader').addClass('disable');
    };
}(jQuery));